module.exports = __webpack_public_path__ + "/static/assets/db50bd7dacd69c9e8397eb83b4d83c3b.svg";